module.exports = __webpack_public_path__ + "8c89bf87a696bfd33981b2f848fbeeff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/night_1.jpg
// module id = 1759
// module chunks = 5